import { render, staticRenderFns } from "./ResultsModal.vue?vue&type=template&id=272baf1e&scoped=true"
import script from "./ResultsModal.vue?vue&type=script&lang=js"
export * from "./ResultsModal.vue?vue&type=script&lang=js"
import style0 from "./ResultsModal.vue?vue&type=style&index=0&id=272baf1e&prod&lang=scss&scoped=true"
import style1 from "./ResultsModal.vue?vue&type=style&index=1&id=272baf1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272baf1e",
  null
  
)

export default component.exports